import React, { useMemo } from "react";

const bdtAmountFmt = new Intl.NumberFormat("en-BD", {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

/** Hero balance: small BDT label + large amount (e.g. BDT 50,533.01). */
export default function WalletBalanceDisplay({ value, className = "wallet-balance-hero", size = "hero", style }) {
  const formatted = useMemo(() => {
    const n = Number(value);
    if (!Number.isFinite(n)) return null;
    return bdtAmountFmt.format(n);
  }, [value]);

  if (formatted == null) {
    return (
      <p className={className} style={style}>
        —
      </p>
    );
  }

  return (
    <p
      className={[className, size === "compact" ? "wallet-balance-hero--compact" : ""].filter(Boolean).join(" ")}
      style={style}
    >
      <span className="wallet-balance-hero__currency">BDT</span>
      <span className="wallet-balance-hero__amount">{formatted}</span>
    </p>
  );
}
